import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Stack,
  Alert,
  AlertTitle,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
//import { yellow } from "@mui/material/colors";
import HighlightIcon from "@mui/icons-material/Highlight";
import { ReactComponent as MarkNotesIcon } from "../../logo.svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSignupMutation } from "./authApiSlice";
//const color = yellow[500];

const PWD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

function Signup() {
  const navigate = useNavigate();
  const location = useLocation();
  const [newUser, setNewUser] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorPw, setErrorPw] = useState({
    password: "",
  });
  const [signupNewUser, { isLoading, isSuccess, isError, error }] =
    useSignupMutation();
  function handleOnChange(event) {
    const { value, name } = event.target;
    setNewUser((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
    validateInput(event);
  }
  async function handleSubmit(e) {
    e.preventDefault();
    if (!errorPw.password) {
      await signupNewUser(newUser);
    }
  }
  function handleClickShowPassword() {
    setShowPassword((show) => !show);
  }
  function handleMouseDownPassword(event) {
    event.preventDefault();
  }
  function validateInput(e) {
    let { name, value } = e.target;
    setErrorPw((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password!";
          } else if (!PWD_REGEX.test(value)) {
            stateObj[name] =
              "Password must contain Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character!";
          }
          break;
        default:
          break;
      }

      return stateObj;
    });
  }
  useEffect(() => {
    if (isSuccess) {
      setNewUser({
        username: "",
        email: "",
        password: "",
      });
      //navigate("/login", { state: { signup: true }, replace: true });
    }
  }, [isSuccess, navigate]);
  if (isLoading) {
    return (
      <Stack alignItems="center" spacing={5}>
        <CircularProgress />
      </Stack>
    );
  }
  const errClass = isError ? "errmsg" : "offscreen";

  return (
    <div>
      <header className="signup-header">
        <MarkNotesIcon />
        <h1>Sign Up</h1>
      </header>
      {isSuccess && (
        <Alert
          variant="filled"
          severity="success"
          sx={{
            p: "35px",
            width: "35%",
          }}
        >
          <AlertTitle>
            Welcome to MarkNotes! You have successfully registered!
          </AlertTitle>
          <Link to="/login" state={{ from: location }} replace>
            <p
              style={{
                fontSize: "1.25rem",
                textDecoration: "underline",
              }}
            >
              Login
            </p>
          </Link>
        </Alert>
      )}
      <form className="signup" onSubmit={handleSubmit}>
        <Stack spacing={2} sx={{ marginBottom: 4, width: "100%" }}>
          <TextField
            type="text"
            variant="outlined"
            label="User Name"
            name="username"
            onChange={(e) => handleOnChange(e)}
            value={newUser.username}
            fullWidth
            required
          />
          <TextField
            type="email"
            variant="outlined"
            label="Email"
            name="email"
            onChange={(e) => handleOnChange(e)}
            value={newUser.email}
            fullWidth
            required
            sx={{ mb: 4 }}
          />
          <TextField
            type={showPassword ? "text" : "password"}
            label="Password"
            name="password"
            variant="outlined"
            onChange={(e) => handleOnChange(e)}
            value={newUser.password}
            required
            fullWidth
            sx={{ mb: 4 }}
            error={errorPw.password !== ""}
            helperText={errorPw.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <p className={errClass}>{error?.data?.message}</p>
          <Button className="signup-btn" variant="outlined" type="submit">
            Sign Up
          </Button>
          <p>
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </Stack>
      </form>
    </div>
  );
}

export default Signup;
